import { Component, OnInit } from '@angular/core';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { ActionState, BaseComponentConfig, ComponentConfig, ConfigOptions, UpdateComponentStoreService, ViewContainersService, getColumnFieldTitles, getFields } from '@urbannex/view-containers';
import { IMG_FORMS } from '../../forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';

@Component({
  selector: 'ubs-manage-images',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./manage-images.component.scss']
})
export class ManageImagesComponent extends BaseComponentConfig implements OnInit{
  
  productId:string;
  manageImgOptions:ConfigOptions = {
    name: 'Upload Additional Images',
    title: 'Upload Additional Images',
    defaultAction:ActionState.RELATE,
    listForm: undefined,
    findForm: undefined,
    addForm: undefined,
    actions: [],
    settings: [],
    breadCrumbData:{
      displayPrefix:"Gallery For ",
      label:"",
      level:1,
      selectedValue:{
      "event":"list",
      "type":"ProductImages",
      "data":{
          formData:{
          formName:"ProductImages",
          formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
          listType:"grid"
          },
          "endPoint":""
      }
      },
      addFormText:"Upload Product Image",
      editFormText:"Update Product Image"
  },
    relations:[
      {
        title:"Manage Product Images",
        addContainerTitle:"Default Image", 
        listContainerTitle:"Manage Images", 
        keyMap:{fieldName:"productId"}, 
        addFormName:"ShowDefaultImage", 
        listFormName:"ListImageManage",
        addForm:new OfbizForm({
          formName:"ShowDefaultImage",
          local:true,
          formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
          fields:getFields("ShowDefaultImage",IMG_FORMS),
        }),
        //ListImageUpload
        listForm:new OfbizList({
          listFormName:"ListImageManage",
          listFormLocation:"component://kwikstore/widget/ImageManagementForms.xml",
          columnFields:getFields("ListImageManage",IMG_FORMS),
          columnFieldTitles:getColumnFieldTitles("ListImageManage",IMG_FORMS),
          fieldFormFields:getFields("ListImageManage",IMG_FORMS),
          emptyListMessage:"No images found",
          listType:"multi",
          remoteFormData:{
            formData:{
              formName:"ListImageManage",
              formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
              viewIndex:0,
              listType:"multi",
            },
            appContext:"catalog",
            parameters:{"productId":""}
    
          }
        })         
      }
    ]
  }

  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    private http:HttpClient,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService) {
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService);
    this.route.paramMap.subscribe((params) => {
      this.routerParams = params;
      this.productId = params.get("productId");
      //console.log(params.get("productId"));

      this.manageImgOptions.relations[0].listForm.remoteFormData.parameters["productId"] = params.get("productId");
      console.log(this.manageImgOptions.relations[0].listForm);
    })
    this.componentConfig = new ComponentConfig(this.manageImgOptions);
   }

  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }
}
